var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrafic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 118,
    viewBox: "0 0 123 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64.7097V57.0968H22.8272V64.7097H0ZM23.2381 107.844L17.8508 102.363L33.8299 86.376L39.3084 91.7659L23.2381 107.844ZM33.8299 35.4305L17.8508 19.4434L23.2381 13.9621L39.3084 30.0405L33.8299 35.4305ZM113.847 118L80.0396 84.1835L72.8719 106.284L56.1853 51.2425L111.792 67.9299L89.7868 75.7712L122.917 108.925L113.847 118ZM61.7551 22.8387V0H69.3641V22.8387H61.7551ZM97.2818 35.4305L91.8032 30.0405L107.874 13.9697L113.261 19.352L97.2818 35.4305Z",
    fill: "#062F85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafic);
export default __webpack_public_path__ + "static/media/trafic.d03459d3a56a286cdf3d47158f58abb6.svg";
export { ForwardRef as ReactComponent };